import React, { useState } from "react";
import { Row, Col, Input, Select, Button, Form, DatePicker } from "antd";

const { Option } = Select;
const { RangePicker } = DatePicker;

const BonusCampaignFilters = ({ filters = {}, onFiltersChange }) => {
  const [form] = Form.useForm();
  const [searchField, setSearchField] = useState("name");

  const onFinish = (values) => {
    onFiltersChange({
      ...values,
      searchField,
    });
  };

  const handleReset = () => {
    form.resetFields();
    setSearchField("name");
    onFiltersChange({});
  };

  const handleSearch = (search) => {
    const values = form.getFieldsValue();

    onFiltersChange({
      ...values,
      search,
      searchField,
    });
  };

  const searchBy = (
    <Select
      value={searchField}
      onChange={setSearchField}
      style={{ width: 130 }}
    >
      <Option value="name">Name</Option>
      <Option value="campaignId">Id</Option>
    </Select>
  );

  return (
    <Form
      form={form}
      name="bonus_campaign_filters"
      onFinish={onFinish}
      layout="vertical"
      initialValues={filters}
    >
      <Row gutter={[16, 16]}>
        {/* Date */}
        <Col xs={24} sm={12} md={6}>
          <Form.Item label="Campaign Date" name="dateRange">
            <RangePicker style={{ width: "100%" }} />
          </Form.Item>
        </Col>

        {/* Search */}
        <Col xs={24} sm={12} md={12}>
          <Form.Item label="Search" name="search">
            <Input.Search
              addonBefore={searchBy}
              placeholder="Search"
              onSearch={handleSearch}
              allowClear
            />
          </Form.Item>
        </Col>

        {/* Active */}
        <Col xs={24} sm={12} md={6}>
          <Form.Item label="Active" name="isActive">
            <Select placeholder="All" allowClear>
              <Option value={true}>Yes</Option>
              <Option value={false}>No</Option>
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={6}>
          <Form.Item label="Target Users" name="category">
            <Select placeholder="All" allowClear>
              <Option value="all">All Users</Option>
              <Option value="userStatus">By User Status</Option>
            </Select>
          </Form.Item>
        </Col>

        {/* Buttons */}
        <Col
          xs={24}
          sm={12}
          md={6}
          style={{ display: "flex", alignItems: "end" }}
        >
          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ marginRight: 8 }}>
              Filter
            </Button>
            <Button onClick={handleReset}>Reset</Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default BonusCampaignFilters;
